export default __webpack_public_path__ + "static/media/transportation.6d118b5a.svg";